import { AuthService } from '../../core/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/add/observable/throw';
import { TranslateService } from '@ngx-translate/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { UserService } from '../../services/user.service';
import { ActivePages, EventTrackerService, Page, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { CommonConstant, FacebookAuthSource } from '../../app.constants';
import { FbTestingPageComponent } from '../../fb-testing-page/fb-testing-page.component';
import { environment } from '../../../environments/environment';
import { AppSettings } from '../../utils/app-settings';
import { FbAuthorisationError } from '../../fb-testing-page/fb-login-fail/fb-login-fail.component';
var InfluencerLoginComponent = /** @class */ (function () {
    function InfluencerLoginComponent(auth, route, router, translate, placeholderService, userService, eventTracker) {
        this.auth = auth;
        this.route = route;
        this.router = router;
        this.translate = translate;
        this.placeholderService = placeholderService;
        this.userService = userService;
        this.eventTracker = eventTracker;
        this.env = environment;
    }
    InfluencerLoginComponent.prototype.ngOnInit = function () {
        this.user = new FormGroup({
            username: new FormControl(null, [
                Validators.required,
                Validators.email
            ]),
            password: new FormControl(null, [
                Validators.required
            ])
        });
        var facebookAppId = this.env.facebookAppId;
        var fbRedirectUri = this.env.fbRedirectUri;
        var fbAppState = this.env.fbAppState + ";source=" + FacebookAuthSource.ORGANIC_LOGIN;
        var scopes = AppSettings.facebookAuthScopes();
        this.facebookAuthUrl = FbTestingPageComponent.FB_GRAPH_API + "/dialog/oauth?client_id=" + facebookAppId + "&redirect_uri=" + fbRedirectUri + "&state=" + fbAppState + "&response_type=code&scope=" + scopes;
        this.handleAuthorizeFail();
    };
    InfluencerLoginComponent.prototype.onSubmit = function (_a) {
        var _this = this;
        var value = _a.value, valid = _a.valid;
        if (valid) {
            this.isLoggedInWithAdvertiserAccount = false;
            this.placeholderService.show(CommonConstant.LOGIN_PLACEHOLDER);
            this.auth.login(value.username, value.password, function (data) {
                _this.loadUserData();
            }, function (error) {
                _this.handleLoginError(error);
                _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
            });
        }
        return false;
    };
    InfluencerLoginComponent.prototype.signInWithFacebook = function () {
        window.location.href = this.facebookAuthUrl;
    };
    Object.defineProperty(InfluencerLoginComponent.prototype, "hasNoBusinessAccountError", {
        get: function () {
            return this.errorCode && this.errorCode === FbAuthorisationError.NO_BUSINESS_USER;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerLoginComponent.prototype, "hasMissingPermissionError", {
        get: function () {
            return this.errorCode && this.errorCode === FbAuthorisationError.MISSING_PERMISSION;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerLoginComponent.prototype, "hasFacebookGeneralPermissionError", {
        get: function () {
            return this.errorCode && (this.errorCode === FbAuthorisationError.PAGE_SUBSCRIPTION_FAILED
                || this.errorCode === FbAuthorisationError.FACEBOOK_ERROR);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerLoginComponent.prototype, "hasErrorSelectUser", {
        get: function () {
            return this.errorCode && this.errorCode === FbAuthorisationError.ERROR_SELECT_USER;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerLoginComponent.prototype, "hasError", {
        get: function () {
            return this.errorCode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerLoginComponent.prototype, "hasFbAuthError", {
        get: function () {
            return this.errorCode && (this.errorCode === FbAuthorisationError.MISSING_CODE
                || this.errorCode === FbAuthorisationError.INVALID_INFLUENCER
                || this.errorCode === FbAuthorisationError.UNABLE_TO_COLLECT_BACKWARD
                || this.errorCode === FbAuthorisationError.INVALID_TOKEN);
        },
        enumerable: true,
        configurable: true
    });
    InfluencerLoginComponent.prototype.handleAuthorizeFail = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (res) {
            if (res.error) {
                _this.errorCode = res.error;
            }
        });
    };
    InfluencerLoginComponent.prototype.loadUserData = function () {
        var _this = this;
        this.auth.getUserData(function (user) {
            if (user.data.company.influencer !== true) {
                _this.auth.resetUserData();
                _this.isLoggedInWithAdvertiserAccount = true;
                _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
                return;
            }
            if (!_this.userService.getCompanyId()) {
                _this.userService.setCurrentCompanyForInfluencer(_this.auth.getUser().companyId);
            }
            _this.eventTracker.hasIdentifiedObserver.subscribe(function (res) {
                if (res) {
                    _this.eventTracker.trackUserAction(UserActionType.LOGIN, Page.LOGIN, undefined, undefined, undefined, {
                        type: ActivePages.LOGIN,
                    });
                }
            });
            _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
            var redirectUrl = _this.getRedirectUrl();
            if (redirectUrl) {
                _this.router.navigateByUrl(redirectUrl);
            }
            else if (AppSettings.isDisableHomepage()) {
                _this.router.navigate(['dashboard', 'details']);
            }
            else {
                _this.router.navigate(['dashboard', 'home']);
            }
        }, function (err) {
            _this.placeholderService.hide(CommonConstant.LOGIN_PLACEHOLDER);
            _this.errorCode = err.error.message;
            _this.auth.logout();
        });
    };
    InfluencerLoginComponent.prototype.handleLoginError = function (error) {
        if (error.error.data === 'invalid_credential') {
            this.errorCode = error.error.message;
        }
        else if (error.status === 400) {
            this.errorCode = this.translate.instant('LOGIN.wrong_username_password');
        }
        else {
            this.errorCode = error.error.message;
        }
    };
    InfluencerLoginComponent.prototype.getRedirectUrl = function () {
        var returnUrl = null;
        if (this.route.snapshot.queryParams['target_url']) {
            returnUrl = decodeURIComponent(this.route.snapshot.queryParams['target_url']);
        }
        return returnUrl;
    };
    return InfluencerLoginComponent;
}());
export { InfluencerLoginComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-auth/influencer-login/influencer-login.component.ts.pre-build-optimizer.js